var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIconReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d2d1f0d1-c400-44ac-a931-2a41cc8ae1cc"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "03e63d3d-93b4-4fa9-82e8-2947875eb57e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.11 0 0 2.11 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -1.56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-256, -254.44)",
    d: "M 512 256 C 512 114.61500000000001 397.385 0 256 0 C 114.61500000000001 0 0 114.615 0 256 C 0 383.777 93.616 489.685 216 508.89 L 216 330 L 151 330 L 151 256 L 216 256 L 216 199.6 C 216 135.44 254.219 100 312.695 100 C 340.704 100 370 105 370 105 L 370 168 L 337.719 168 C 305.918 168 296 187.733 296 207.978 L 296 256 L 367 256 L 355.65 330 L 296 330 L 296 508.89 C 418.385 489.685 512 383.777 512 256 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.5 50)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(24,119,242)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-260.5, -306)",
    d: "M 355.65 330 L 367 256 L 296 256 L 296 207.978 C 296 187.733 305.917 168 337.719 168 L 370 168 L 370 105 C 370 105 340.703 100 312.695 100 C 254.219 100 216 135.44 216 199.6 L 216 256 L 151 256 L 151 330 L 216 330 L 216 508.89 C 229.033 510.935 242.392 512 256 512 C 269.608 512 282.966 510.935 296 508.89 L 296 330 L 355.65 330 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconReverse);
export default __webpack_public_path__ + "static/media/facebook-icon-reverse.37ee1848426b03fccf44a2290cce5d07.svg";
export { ForwardRef as ReactComponent };